import * as React from 'react'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'

import { Selects } from './Selects'

import { DESCRIPTION, TITLE } from '../constants'
import { useGiftIdeaListing } from '../hooks/useGiftIdeaListing'

export function Hero(): React.ReactElement {
  const { resetFilters, apply, query } = useGiftIdeaListing()

  return (
    <Wrapper>
      <plume.styles.heading.L as="h1" asDesktop="XL">
        {TITLE}
      </plume.styles.heading.L>

      <plume.styles.copy.S as="h2">{DESCRIPTION}</plume.styles.copy.S>

      <Selects />

      {Object.keys(query.facetFilters ?? {}).length !== 0 && (
        <plume.LinkAsButton kind="secondary" onClick={() => apply(resetFilters())}>
          <plume.glyphs.stroke.Refresh size={18} />
          Réinitialiser les filtres
        </plume.LinkAsButton>
      )}

      <XmasImage
        src={`${process.env.ASSET_PREFIX}/assets/images/xmas/xmas-gift-ideas.png`}
        srcSet={`${process.env.ASSET_PREFIX}/assets/images/xmas/xmas-gift-ideas@2x.png 2x, ${process.env.ASSET_PREFIX}/assets/images/xmas/xmas-gift-ideas@3x.png 3x`}
      />
    </Wrapper>
  )
}

const XmasImage = styled(plume.Picture)`
  margin: 24px auto 0;
  width: 125px;
  z-index: 0;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    bottom: 0px;
    margin: 0;
    position: absolute;
    right: 18px;
    width: 134px;
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    right: 24px;
    width: 150px;
  }

  @media screen and (min-width: 1250px) {
    width: 175px;
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP_L} {
    right: 32px;
    width: 200px;
  }
`

const Wrapper = styled.section`
  border: 5px solid ${plume.COLORS.SECONDARY_GREEN_LIGHT};
  padding: 45px 13.5px 24px;
  position: relative;
  text-align: center;
  margin: 0 -2.5px 40px -2.5px;

  ${plume.styles.heading.L} {
    color: ${plume.COLORS.SECONDARY_MINT};
    background: ${plume.COLORS.SECONDARY_GREEN_LIGHT};
    display: inline-block;
    padding: 4px 16px 12px;
    position: absolute;
    top: -28px;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: white 0px 0px 0px 15px;
    white-space: pre;
  }

  ${plume.styles.copy.S} {
    max-width: 500px;
    margin: 0 auto;
    text-align: center;
    margin-bottom: 24px;
  }

  ${plume.LinkAsButton} {
    ${plume.styles.copy._smallStyle};
    color: ${plume.COLORS.GREY_SHADE_1};
    max-width: 500px;
    margin: 24px auto 0;

    ${plume.glyphs.stroke.Refresh} {
      margin-right: 6px;
      color: ${plume.COLORS.GREY_SHADE_7};
    }

    @media screen and ${plume.BREAKPOINTS.TABLET} {
      margin-top: 32px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    padding: 59px 13.5px 40px;
    ${plume.styles.heading.L} {
      top: -34px;
    }
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    padding: 59px 40px 40px;
  }
`
